import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Calendar } from 'lucide-react';
import Layout from '../components/Layout';
import PageHeader from '../components/layout/PageHeader';
import { staffCardClass, staffInputClass } from '../components/layout/staffPageStyles';
import { useLanguage } from '../contexts/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export default function PromotionsCalendarPage() {
  const { t, formatDate } = useLanguage();
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [calendar, setCalendar] = useState(null);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/public/promotions/calendar/${month}`).then(r => {
      setCalendar(r.data);
    }).catch(() => setCalendar(null));
  }, [month]);

  return (
    <Layout>
      <div className="max-w-6xl mx-auto space-y-6" data-testid="promotions-calendar-page">
        <PageHeader
          title={t('promosCalendar.title')}
          subtitle={t('promosCalendar.subtitle')}
          backTo="/dashboard"
          icon={Calendar}
          testId="promotions-calendar-header"
          actions={(
            <input
              type="month"
              value={month}
              onChange={e => setMonth(e.target.value)}
              className={`${staffInputClass} w-auto`}
              data-testid="promotions-calendar-month"
            />
          )}
        />

        {!calendar?.days?.length && (
          <p className="text-center text-gray-500 py-12">{t('promosCalendar.empty')}</p>
        )}

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {(calendar?.days || []).map(d => (
            <div key={d.date} className={`${staffCardClass} p-4 border-amber-500/20`}>
              <div className="text-amber-400 font-bold text-lg">
                {formatDate(d.date, { weekday: 'long', day: 'numeric', month: 'long' })}
              </div>
              <ul className="mt-3 space-y-2">
                {(d.products || []).map(p => (
                  <li key={p.product_id} className="flex justify-between items-center bg-white/[0.03] rounded-lg p-2 border border-white/5">
                    <span className="truncate mr-2 text-sm text-gray-200">{p.product_designation}</span>
                    <span className="text-rose-400 font-bold text-sm">−{p.discount_percent}%</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
